export default __webpack_public_path__ + "locales/tr/SalesDepartmentRequestDialog.json?hash=476b74dbaf9f351652cea8a35fbc9070";